// extracted by mini-css-extract-plugin
export default {"root":"JWVEh","itemTitle":"WmXBc"};